var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11782_1354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9492 2.5697L0.780473 13.0832C0.764309 13.0894 0.748639 13.0969 0.733598 13.1054C0.513286 13.2302 -1.02421 14.1707 1.14375 15.0138L1.16602 15.022L7.63536 17.1121C7.68471 17.1281 7.73698 17.1332 7.78849 17.1269C7.84001 17.1206 7.88953 17.1032 7.9336 17.0758L23.9795 7.06443C24.0188 7.03988 24.0626 7.02335 24.1084 7.0158C24.3316 6.97888 24.9744 6.90974 24.5678 7.42595C24.1078 8.01189 13.1479 17.8334 11.9314 18.9226C11.8613 18.9856 11.8179 19.073 11.8102 19.167L11.2793 25.4951C11.2792 25.5595 11.2942 25.6231 11.323 25.6808C11.3518 25.7385 11.3936 25.7886 11.4451 25.8273C11.5183 25.8734 11.6043 25.8947 11.6905 25.8882C11.7767 25.8816 11.8585 25.8476 11.9238 25.791L15.7676 22.3556C15.8283 22.3014 15.9058 22.2695 15.9871 22.2654C16.0684 22.2612 16.1487 22.285 16.2147 22.3328L22.9207 27.2019L22.9424 27.2166C23.1047 27.3168 24.8578 28.3369 25.3641 26.0588L29.993 4.04802C29.9994 3.9783 30.0621 3.21189 29.5143 2.75896C28.9389 2.28552 28.1244 2.52459 28.002 2.55037C27.9839 2.5554 27.9663 2.56186 27.9492 2.5697Z",
    fill: "#009EEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11782_1354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.32564b21d356089196126d5e55f45e88.svg";
export { ForwardRef as ReactComponent };